module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/hidden-keys.js
// module id = 229
// module chunks = 1